import React from 'react'

type Props = {
    progress?   : number
    phase?      : string
}

export default function LoadingScreen({ progress, phase }: Props) {

    const hasProgress = progress !== undefined

    const outerStyle: any = {
        display         : 'flex',
        flexDirection   : 'column',
        alignItems      : 'center',
        justifyContent  : 'center',
        minHeight       : '200px',
        fontSize        : '1.5rem',
    }

    return (
        <div className="loading" style={outerStyle}>

            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                {[0, 1, 2].map(i => (
                    <span key={i} style={{
                        display         : 'inline-block',
                        width           : '12px',
                        height          : '12px',
                        borderRadius    : '50%',
                        background      : '#333',
                        animation       : `loading-bounce 1s infinite ${i * 0.2}s alternate`,
                    }} />
                ))}
            </div>

            <div style={{ fontSize: '1rem', color: '#555', marginBottom: '12px', minHeight: '1.4em' }}>
                {phase || 'Loading...'}
            </div>

            {hasProgress && (
                <>
                    <div style={{
                        width           : '220px',
                        height          : '6px',
                        background      : '#ddd',
                        borderRadius    : '3px',
                        overflow        : 'hidden',
                        marginBottom    : '6px',
                    }}>
                        <div style={{
                            width           : `${progress}%`,
                            height          : '100%',
                            background      : '#333',
                            borderRadius    : '3px',
                            transition      : 'width 0.4s ease',
                        }} />
                    </div>
                    <div style={{ fontSize: '0.85rem', color: '#888' }}>
                        {progress}%
                    </div>
                </>
            )}

            <style>{`
                @keyframes loading-bounce {
                    from { transform: translateY(0);     opacity: 0.5; }
                    to   { transform: translateY(-15px); opacity: 1;   }
                }
            `}</style>
        </div>
    )
}
